// extracted by mini-css-extract-plugin
export default {"btn":"Avatar_btn__wugVR","container":"Avatar_container__ZetAw","img":"Avatar_img__t1Orj","authLink":"Avatar_authLink__P442r","svg":"Avatar_svg__ndiwS"};